<template>
  <div class="row">
    <div class="col outer-box">
      <div class="innerBox" style="height: 100%">
        <h2 style="text-align: center; font-weight: 700">Top 10 Sales By Sub Series</h2>
        <div ref="salesBySeries" style="height: 480px"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import am4themesAnimated from '@amcharts/amcharts4/themes/animated'

export default {
  data () {
    return {
      chart: null
    }
  },
  props: ['filterUrl'],
  mounted () {
    this.createChart()
  },
  watch: {
    'filterUrl' : function () {
      this.fetchData()
    }
  },
  methods: {
    fetchData () {
      this.$http.get('/api/h1/regional-sales/top-ten-by-series?' + this.filterUrl)
      .then((resp)=>{
        var data = resp.data.data;
        this.data = (data != null && data.length != 0) ? data : [{sub_series : 'No Data', points : 1}];
      })
      .then(()=>{
        this.generateData();
      })
      .catch((err)=>{
        console.log(err);
      })
    },
    calculateTotal () {
      let total = 0

      for(var i = 0 ; i < this.data.length ; i++) {
        if(total < this.data[i].points) {
          total = this.data[i].points
        }
      }

      return total
    },
    generateData () {
      // Add data
      let masterImagedata = [{
        'name': 'Genio',
        'bullet': 'https://cdnhonda.azureedge.net/uploads/products/25183.jpg'
      }, {
        'name': 'BeAT',
        'bullet': 'https://cdnhonda.azureedge.net/uploads/products/63228.jpg'
      }, {
        'name': 'Monkey',
        'bullet': 'https://cdnhonda.azureedge.net/uploads/products/89252.png'
      }, {
        'name': 'Scoopy',

        'bullet': 'https://cdnhonda.azureedge.net/uploads/products/25324.png'
      }, {
        'name': 'PCX 150',
        'bullet': 'https://cdnhonda.azureedge.net/uploads/products/88723.png'
      }, {
        'name': 'ADV 150',
        'bullet': 'https://cdnhonda.azureedge.net/uploads/products/48889.jpg'
      }, {
        'name': 'SHX150i',
        'bullet': 'https://cdnhonda.azureedge.net/uploads/products/39999.png'
      }, {
        'name': 'Forza',
        'bullet': 'https://cdnhonda.azureedge.net/uploads/products/83922.png'
      }, {
        'name': 'CRF150L',
        'bullet': 'https://cdnhonda.azureedge.net/uploads/products/79470.png'
      }, {
        'name': 'Revo X',
        'bullet': 'https://cdnhonda.azureedge.net/uploads/products/67412.png'
      }, {
        'name': 'Supra X',
        'bullet': 'https://cdnhonda.azureedge.net/uploads/products/43165.png'
      }, {
        'name' : 'Vario',
        bullet : 'https://www.astra-honda.com/uploads/products/25637.jpg'
      }]

      let total = this.calculateTotal()

      for (var i = 0 ; i < this.data.length ; i++) {
        this.data[i].sub_series = this.data[i].sub_series ? this.data[i].sub_series : 'Unknown'
        if(this.data[i].points / total * 100 > 10)
          for (var j = 0 ; j < masterImagedata.length ; j++) {
            if(this.data[i].sub_series.toLowerCase().includes(masterImagedata[j].name.toLowerCase())){
              this.data[i].bullet = masterImagedata[j].bullet
              break
            }
          }
        else 
          this.data[i].bullet = null
        this.data[i].color = this.chart.colors.next()
      }

      let length = this.chart.data.length;
      this.chart.addData(this.data , length)
    },
    createChart () {
      /* Chart code */
      // Themes begin
      am4core.useTheme(am4themesAnimated)
      // Themes end

      this.chart = am4core.create(this.$refs.salesBySeries, am4charts.XYChart)

      // Create axes
      let categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis())
      categoryAxis.dataFields.category = 'sub_series'
      categoryAxis.renderer.grid.template.disabled = true
      categoryAxis.renderer.minGridDistance = 30
      categoryAxis.renderer.inside = false
      categoryAxis.renderer.labels.template.fill = am4core.color('#000')
      categoryAxis.renderer.labels.template.fontSize = 12

      let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis())
      valueAxis.renderer.grid.template.strokeDasharray = '4,4'
      valueAxis.renderer.labels.template.disabled = true
      valueAxis.min = 0

      // Do not crop bullets
      this.chart.maskBullets = false

      // Remove padding
      this.chart.paddingBottom = 0

      // Create series
      let series = this.chart.series.push(new am4charts.ColumnSeries())
      series.dataFields.valueY = 'points'
      series.dataFields.categoryX = 'sub_series'
      series.columns.template.propertyFields.fill = 'color'
      series.columns.template.propertyFields.stroke = 'color'
      series.columns.template.column.cornerRadiusTopLeft = 15
      series.columns.template.column.cornerRadiusTopRight = 15
      series.columns.template.tooltipText = '{categoryX}: [bold]{valueY}[/b]'

      // Add bullets
      let bullet = series.bullets.push(new am4charts.Bullet())
      let image = bullet.createChild(am4core.Image)
      image.horizontalCenter = 'middle'
      image.verticalCenter = 'bottom'
      image.dy = 10
      image.y = am4core.percent(100)
      image.propertyFields.href = 'bullet'
      image.tooltipText = series.columns.template.tooltipText
      image.propertyFields.fill = 'color'
      image.filters.push(new am4core.DropShadowFilter())
    }
  }
}
</script>

<style scoped>

</style>
